// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1gVT4","large":"styles_large__4W0fM"};